export default class AutorecognitionTrackerSettings {
    constructor(dto) {
        this.title = '';
        this.color = '';
        this.errorColor = '#ff5252';
        this.pendingColor = '#fb8c00';
        this.recognizedColor = '#4caf50';
        this.errorTextColor = '#ffffff';
        this.pendingTextColor = '#ffffff';
        this.recognizedTextColor = '#ffffff';
        this.enableHorizontalScrolling = false;

        if (dto) {
            this.title = dto.Title || '';
            this.color = dto.Color || '';
            this.errorColor = dto.ErrorColor || '#ff5252';
            this.pendingColor = dto.PendingColor || '#fb8c00';
            this.recognizedColor = dto.RecognizedColor || '#4caf50';
            this.errorTextColor = dto.ErrorTextColor || '#ffffff';
            this.pendingTextColor = dto.PendingTextColor || '#ffffff';
            this.recognizedTextColor = dto.RecognizedTextColor || '#ffffff';
            this.enableHorizontalScrolling = dto.EnableHorizontalScrolling == 'true';
        }
    }

    toDto() {
        return {
            Title: this.title,
            Color: this.color,
            ErrorTextColor: this.errorTextColor,
            ErrorColor: this.errorColor,
            PendingColor: this.pendingColor,
            PendingTextColor: this.pendingTextColor,
            RecognizedTextColor: this.recognizedTextColor,
            RecognizedColor: this.recognizedColor,
            EnableHorizontalScrolling: this.enableHorizontalScrolling.toString(),
        };
    }
}
